<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      <span v-if="membershipLevelData === null">Create Membership Level</span>
      <span v-else>Update Membership Level</span>
    </h6>

    <form id="form-proper">
      <div class="py-2" style="border-bottom: 1px solid #e0e0e0">
        <a-tabs default-active-key="membership-level-info">
          <a-tab-pane key="membership-level-info" tab="Info">
            <div class="row">
              <div class="col">
                <base-input label="Membership Program" required>
                  <a-select
                    v-model="formData.membership_program_id"
                    :disabled="viewMode || membershipLevelData !== null"
                    @change="onChangeMembershipProgram"
                  >
                    <a-select-option
                      v-for="membershipProgram in membershipPrograms"
                      v-bind:value="membershipProgram.id"
                      v-bind:key="membershipProgram.id"
                    >
                      {{ membershipProgram.name }}
                    </a-select-option>
                  </a-select>
                  <div
                    v-if="$v.formData.membership_program_id.$dirty"
                    class="text-danger"
                  >
                    <div
                      class="error"
                      v-if="!$v.formData.membership_program_id.required"
                    >
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Name" required>
                  <a-input
                    v-model.trim="$v.formData.name.$model"
                    :disabled="viewMode"
                  />
                  <div v-if="$v.formData.name.$dirty" class="text-danger">
                    <div class="error" v-if="!$v.formData.name.required">
                      Field is required
                    </div>
                  </div>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Status">
                  <a-select v-model="formData.status" :disabled="viewMode">
                    <a-select-option value="A"> Active </a-select-option>
                    <a-select-option value="I"> Inactive </a-select-option>
                  </a-select>
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input label="Description">
                  <a-textarea
                    v-model="formData.description"
                    :auto-size="{ minRows: 3, maxRows: 3 }"
                    :disabled="viewMode"
                  />
                </base-input>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <base-input required>
                  <b-form-checkbox
                    v-model="redeemFlag"
                    name="check-button"
                    switch
                    :disabled="viewMode"
                  >
                    <label class="form-control-label">Can Redeem</label>
                  </b-form-checkbox>
                </base-input>
              </div>

              <div class="col">
                <base-input required>
                  <b-form-checkbox
                    v-model="earnFlag"
                    name="check-button"
                    switch
                    :disabled="viewMode"
                  >
                    <label class="form-control-label">Can Earn</label>
                  </b-form-checkbox>
                </base-input>
              </div>
            </div>
            <div>
              <div v-if="earnFlag" class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                      block
                      v-b-toggle:accordion-basic
                      class="basic-earning-header"
                      variant="primary"
                      >Basic Earning Type<sup
                        ><span style="color: red">*</span></sup
                      ></b-button
                    >
                  </b-card-header>
                  <b-collapse
                    id="accordion-basic"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div class="row">
                          <div class="col">
                            <base-input label="Amount Increment" required>
                              <a-input
                                v-model.trim="
                                  $v.formData.amount_increment.$model
                                "
                                :disabled="viewMode"
                              />
                              <div
                                v-if="$v.formData.amount_increment.$dirty"
                                class="text-danger"
                              >
                                <div
                                  class="error"
                                  v-if="!$v.formData.amount_increment.required"
                                >
                                  Field is required
                                </div>

                                <div
                                  class="error"
                                  v-else-if="
                                    !$v.formData.amount_increment.decimal
                                  "
                                >
                                  Value must be a valid number
                                </div>

                                <div
                                  class="error"
                                  v-else-if="
                                    !$v.formData.amount_increment.minValue
                                  "
                                >
                                  Minimum value of
                                  {{
                                    $v.formData.amount_increment.$params
                                      .minValue.min
                                  }}
                                </div>
                              </div>
                            </base-input>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col">
                            <base-input label="Points Earned" required>
                              <a-input
                                v-model.trim="$v.formData.points_earned.$model"
                                :disabled="viewMode"
                              />
                              <div
                                v-if="$v.formData.points_earned.$dirty"
                                class="text-danger"
                              >
                                <div
                                  class="error"
                                  v-if="!$v.formData.points_earned.required"
                                >
                                  Field is required
                                </div>

                                <div
                                  class="error"
                                  v-else-if="!$v.formData.points_earned.decimal"
                                >
                                  Value must be a valid number
                                </div>

                                <div
                                  class="error"
                                  v-else-if="
                                    !$v.formData.points_earned.minValue
                                  "
                                >
                                  Minimum value of
                                  {{
                                    $v.formData.points_earned.$params.minValue
                                      .min
                                  }}
                                </div>
                              </div>
                            </base-input>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col">
                            <base-input label="Min. Amount to Earn" required>
                              <a-input
                                v-model.trim="
                                  $v.formData.minimum_amount_to_earn.$model
                                "
                                :disabled="viewMode"
                              />
                              <div
                                v-if="$v.formData.minimum_amount_to_earn.$dirty"
                                class="text-danger"
                              >
                                <div
                                  class="error"
                                  v-if="
                                    !$v.formData.minimum_amount_to_earn.required
                                  "
                                >
                                  Field is required
                                </div>

                                <div
                                  class="error"
                                  v-else-if="
                                    !$v.formData.minimum_amount_to_earn.decimal
                                  "
                                >
                                  Value must be a valid number
                                </div>

                                <div
                                  class="error"
                                  v-else-if="
                                    !$v.formData.minimum_amount_to_earn.minValue
                                  "
                                >
                                  Minimum value of
                                  {{
                                    $v.formData.minimum_amount_to_earn.$params
                                      .minValue.min
                                  }}
                                </div>
                              </div>
                            </base-input>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card
                  v-for="(
                    otherEarning, earningType, index
                  ) in formData.other_earning_types"
                  :key="index"
                  no-body
                  class="mb-1 d-none"
                >
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                      block
                      v-b-toggle="'accordion-' + index"
                      variant="secondary"
                      >{{ earningType }}</b-button
                    >
                  </b-card-header>
                  <b-collapse
                    :id="'accordion-' + index"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <b-card-text>
                        <div
                          v-for="(
                            otherEarningValue, otherEarningParam, paramIndex
                          ) in otherEarning"
                          :key="paramIndex"
                          class="row"
                        >
                          <div
                            v-if="
                              otherEarningParam == 'payment_type' ||
                              otherEarningParam == 'transaction_type'
                            "
                            class="col"
                          >
                            <base-input
                              :label="otherEarningParam.replace('_', ' ')"
                              style="text-transform: capitalize"
                            >
                              <a-select
                                v-model="
                                  formData.other_earning_types[earningType][
                                    otherEarningParam
                                  ]
                                "
                                :disabled="viewMode"
                                @change="
                                  otherEarningTypeChecker(earningType, $event)
                                "
                              >
                                <a-select-option
                                  v-for="(
                                    type, earningTypeIndex
                                  ) in earningTypes[otherEarningParam]"
                                  v-bind:value="type"
                                  v-bind:key="earningTypeIndex"
                                >
                                  {{ type }}
                                </a-select-option>
                              </a-select>
                            </base-input>
                          </div>
                          <div v-else class="col">
                            <!-- <div>{{$v.formData.other_earning_types[earningType][otherEarningParam]}}</div> -->
                            <base-input
                              :label="
                                String(otherEarningParam).replace('_', ' ')
                              "
                              style="text-transform: capitalize"
                            >
                              <a-input
                                v-model="
                                  $v.formData.other_earning_types[earningType][
                                    otherEarningParam
                                  ].$model
                                "
                                :disabled="
                                  viewMode || editableEarningTypes[earningType]
                                "
                              />
                              <div
                                v-if="
                                  $v.formData.other_earning_types[earningType][
                                    otherEarningParam
                                  ].$dirty
                                "
                                class="text-danger"
                              >
                                <div
                                  class="error"
                                  v-if="
                                    !$v.formData.other_earning_types[
                                      earningType
                                    ][otherEarningParam].decimal
                                  "
                                >
                                  Value must be a valid number
                                </div>

                                <div
                                  class="error"
                                  v-else-if="
                                    !$v.formData.other_earning_types[
                                      earningType
                                    ][otherEarningParam].minValue
                                  "
                                >
                                  Minimum value of
                                  {{
                                    $v.formData.other_earning_types[
                                      earningType
                                    ][otherEarningParam].$params.minValue.min
                                  }}
                                </div>
                              </div>
                            </base-input>
                          </div>
                        </div>
                      </b-card-text>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div v-if="redeemFlag">
              <div class="row">
                <div class="col">
                  <base-input label="Point Equivalent" required>
                    <a-input
                      v-model.trim="$v.formData.point_equivalent.$model"
                      :disabled="viewMode"
                    />
                    <div
                      v-if="$v.formData.point_equivalent.$dirty"
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="!$v.formData.point_equivalent.required"
                      >
                        Field is required
                      </div>

                      <div
                        class="error"
                        v-else-if="!$v.formData.point_equivalent.decimal"
                      >
                        Value must be a valid number
                      </div>

                      <div
                        class="error"
                        v-else-if="!$v.formData.point_equivalent.minValue"
                      >
                        Minimum value of
                        {{ $v.formData.point_equivalent.$params.minValue.min }}
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-input label="Min. Points to Allow Redeem" required>
                    <a-input
                      v-model.trim="
                        $v.formData.min_points_to_allow_redemption.$model
                      "
                      :disabled="viewMode"
                    />
                    <div
                      v-if="$v.formData.min_points_to_allow_redemption.$dirty"
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.min_points_to_allow_redemption.required
                        "
                      >
                        Field is required
                      </div>

                      <div
                        class="error"
                        v-else-if="
                          !$v.formData.min_points_to_allow_redemption.decimal
                        "
                      >
                        Value must be a valid number
                      </div>

                      <div
                        class="error"
                        v-else-if="
                          !$v.formData.min_points_to_allow_redemption.minValue
                        "
                      >
                        Minimum value of
                        {{
                          $v.formData.min_points_to_allow_redemption.$params
                            .minValue.min
                        }}
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-input label="Min. Points per Redemption" required>
                    <a-input
                      v-model.trim="
                        $v.formData.min_points_per_redemption.$model
                      "
                      :disabled="viewMode"
                    />
                    <div
                      v-if="$v.formData.min_points_per_redemption.$dirty"
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="!$v.formData.min_points_per_redemption.required"
                      >
                        Field is required
                      </div>

                      <div
                        class="error"
                        v-else-if="
                          !$v.formData.min_points_per_redemption.decimal
                        "
                      >
                        Value must be a valid number
                      </div>

                      <div
                        class="error"
                        v-else-if="
                          !$v.formData.min_points_per_redemption.minValue
                        "
                      >
                        Minimum value of
                        {{
                          $v.formData.min_points_per_redemption.$params.minValue
                            .min
                        }}
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <base-input required>
                  <b-form-checkbox
                    v-model="allowDecimal"
                    name="check-button"
                    switch
                    :disabled="viewMode"
                  >
                    <label class="form-control-label">Allow Decimal</label>
                  </b-form-checkbox>
                </base-input>
              </div>
            </div>
          </a-tab-pane>

          <a-tab-pane
            key="auto-upgrade-info"
            tab="Auto Upgrade"
            :forceRender="true"
          >
            <MembershipLevelAutoUpgradeTab
              ref="autoUpgradeTab"
              :selectedMembershipLevelId="formData.id"
              :membershipSettingsData="formData.membership_settings"
              :viewMode="viewMode"
            />
            <div class="row">
              <div class="col">
                <base-input>
                  <a-checkbox
                    v-model="formData.auto_upgrade"
                    :disabled="viewMode"
                    name="check-button"
                  >
                    <label class="form-control-label">Auto Upgrade</label>
                  </a-checkbox>
                </base-input>
              </div>
            </div>

            <div v-if="formData.auto_upgrade">
              <div class="row">
                <div class="col">
                  <base-input label="Target Membership Level" required>
                    <a-select
                      v-model="
                        formData.auto_upgrade_fields.target_membership_level_id
                      "
                      :disabled="viewMode"
                    >
                      <a-select-option
                        v-for="membershipLevel in membershipLevels"
                        v-bind:value="membershipLevel.id"
                        v-bind:key="membershipLevel.id"
                      >
                        {{ membershipLevel.name }}
                      </a-select-option>
                    </a-select>
                    <div
                      v-if="
                        $v.formData.auto_upgrade_fields
                          .target_membership_level_id.$dirty
                      "
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.auto_upgrade_fields
                            .target_membership_level_id.required
                        "
                      >
                        Field is required
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <base-input label="Upgrade Threshold Amount" required>
                    <a-input
                      v-model.trim="
                        $v.formData.auto_upgrade_fields.upgrade_threshold_amount
                          .$model
                      "
                      :disabled="viewMode"
                    />
                    <div
                      v-if="
                        $v.formData.auto_upgrade_fields.upgrade_threshold_amount
                          .$dirty
                      "
                      class="text-danger"
                    >
                      <div
                        class="error"
                        v-if="
                          !$v.formData.auto_upgrade_fields
                            .upgrade_threshold_amount.required
                        "
                      >
                        Field is required
                      </div>

                      <div
                        class="error"
                        v-else-if="
                          !$v.formData.auto_upgrade_fields
                            .upgrade_threshold_amount.decimal
                        "
                      >
                        Value must be a valid number
                      </div>

                      <div
                        class="error"
                        v-else-if="
                          !$v.formData.auto_upgrade_fields
                            .upgrade_threshold_amount.minValue
                        "
                      >
                        Minimum value of
                        {{
                          $v.formData.auto_upgrade_fields
                            .upgrade_threshold_amount.$params.minValue.min
                        }}
                      </div>
                    </div>
                  </base-input>
                </div>
              </div>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <div
        style="
          position: absolute;
          bottom: 0px;
          right: 0px;
          width: -webkit-fill-available;
          background-color: #f2f2f2;
          padding: 10px;
        "
      >
        <div class="container mx-0 px-0">
          <div class="row">
            <div class="col-auto mr-auto">
              <b-button
                size="sm"
                class="float-md-left"
                style="margin-left: 8px"
                @click.prevent="closeDrawer"
              >
                Cancel
              </b-button>
            </div>
            <div class="col-auto">
              <template>
                <a-spin :spinning="formSubmitting">
                  <b-button
                    v-if="membershipLevelData === null"
                    size="sm"
                    variant="primary"
                    @click.prevent="createMembershipLevel"
                  >
                    Create
                  </b-button>

                  <b-button
                    v-else
                    size="sm"
                    variant="primary"
                    @click.prevent="confirmUpdate"
                    :disabled="viewMode"
                  >
                    Update
                  </b-button>
                </a-spin>
              </template>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  required,
  requiredIf,
  minValue,
  decimal
} from 'vuelidate/lib/validators';
import HTTPRequest from '../../controllers/httpRequest';

const numbersValidation = {
  minValue: minValue(0.1),
  decimal
};

export default {
  name: 'MembershipLevelForm',
  props: {
    membershipLevelData: Object,
    viewMode: Boolean,
    drawerVisible: Boolean
  },
  data() {
    return {
      formSubmitting: false,
      formData: {
        membership_program_id: null,
        name: null,
        description: null,
        status: 'A',
        amount_increment: null,
        points_earned: null,
        earn_flag: false,
        minimum_amount_to_earn: null,
        min_points_to_allow_redemption: null,
        min_points_per_redemption: null,
        redeem_flag: false,
        point_equivalent: null,
        allow_decimal: false,
        auto_upgrade: false,
        auto_upgrade_fields: {
          target_membership_level_id: null,
          upgrade_threshold_amount: null
        },
        other_earning_types: {
          'Payment Earning Type': {
            payment_type: null,
            amount_increment: null,
            points_earned: null
          },
          'Transaction Earning Type': {
            transaction_type: null,
            amount_increment: null,
            points_earned: null
          }
        }
      },
      membershipPrograms: [],
      earningTypes: {
        payment_type: ['None', 'Credit Card', 'GCash', 'Debit Card'],
        transaction_type: ['None', 'Retail', 'Wholesale', 'Special']
      },
      editableEarningTypes: {
        'Payment Earning Type': true,
        'Transaction Earning Type': true
      },
      membershipLevels: []
    };
  },

  validations: {
    formData: {
      membership_program_id: {
        required
      },
      name: { required },
      amount_increment: {
        ...numbersValidation,
        required: requiredIf(function () {
          return this.formData.earn_flag;
        })
      },
      points_earned: {
        ...numbersValidation,
        required: requiredIf(function () {
          return this.formData.earn_flag;
        })
      },
      minimum_amount_to_earn: {
        ...numbersValidation,
        required: requiredIf(function () {
          return this.formData.earn_flag;
        })
      },
      point_equivalent: {
        ...numbersValidation,
        required: requiredIf(function () {
          return this.formData.redeem_flag;
        })
      },
      min_points_to_allow_redemption: {
        ...numbersValidation,
        required: requiredIf(function () {
          return this.formData.redeem_flag;
        })
      },
      min_points_per_redemption: {
        ...numbersValidation,
        required: requiredIf(function () {
          return this.formData.redeem_flag;
        })
      },
      other_earning_types: {
        'Payment Earning Type': {
          amount_increment: { ...numbersValidation },
          points_earned: { ...numbersValidation }
        },
        'Transaction Earning Type': {
          amount_increment: { ...numbersValidation },
          points_earned: { ...numbersValidation }
        }
      },
      auto_upgrade_fields: {
        target_membership_level_id: {
          required: requiredIf(function () {
            return this.formData.auto_upgrade;
          })
        },
        upgrade_threshold_amount: {
          ...numbersValidation,
          required: requiredIf(function () {
            return this.formData.auto_upgrade;
          })
        }
      }
    }
  },

  methods: {
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs'
      );
      this.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    },
    async onChangeMembershipProgram(value) {
      this.getMembershipLevels(value);
    },
    async getMembershipLevels(membershipProgramId) {
      const response = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/membership_levels`,
        { per_page: 1000 }
      );
      this.membershipLevels = response
        .filter((level) => level.name !== this.formData.name)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    async createMembershipLevel() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_membership_levels',
          {
            membership_level: this.formData
          }
        );

        if (response.data) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been created.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error,
              placement: 'topLeft'
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.',
              placement: 'topLeft'
            });
          }
        }

        this.formSubmitting = false;
      } else {
        this.$notification.error({
          message: 'Please fill-up the required(*) fields.',
          placement: 'topLeft'
        });
      }
    },
    async editMembershipLevel() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;

        const response = await HTTPRequest.putRequest(
          '/api/v1/clp_membership_levels/' + this.membershipLevelData.id,
          {
            membership_level: this.formData
          }
        );

        if (response.data) {
          this.closeDrawer();
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Success',
            description: 'Data has been updated.'
          });
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      }
    },

    confirmUpdate() {
      this.$confirm({
        title: 'Confirm',
        content: 'Are you sure you want to commit the changes you made?',
        onOk: () => {
          this.editMembershipLevel();
        }
      });
    },

    closeDrawer() {
      this.clearForm();
      this.$emit('closeDrawer', null);
      this.$v.formData.$reset();
    },
    clearForm() {
      this.formData = {
        membership_program_id: null,
        name: null,
        description: null,
        amount_increment: null,
        points_earned: null,
        earn_flag: false,
        minimum_amount_to_earn: null,
        status: 'A',
        min_points_to_allow_redemption: null,
        min_points_per_redemption: null,
        redeem_flag: false,
        point_equivalent: null,
        allow_decimal: false,
        auto_upgrade: false,
        other_earning_types: {
          'Payment Earning Type': {
            payment_type: null,
            amount_increment: null,
            points_earned: null
          },
          'Transaction Earning Type': {
            transaction_type: null,
            amount_increment: null,
            points_earned: null
          }
        },
        auto_upgrade_fields: {
          target_membership_level_id: null,
          upgrade_threshold_amount: null
        }
      };
    },
    setFormData(data = null) {
      if (data !== null) {
        if (data.other_earning_types == null) {
          data.other_earning_types = {
            'Payment Earning Type': {
              payment_type: null,
              amount_increment: null,
              points_earned: null
            },
            'Transaction Earning Type': {
              transaction_type: null,
              amount_increment: null,
              points_earned: null
            }
          };
        }
        const {
          membership_program_id,
          name,
          description,
          amount_increment,
          points_earned,
          earn_flag,
          minimum_amount_to_earn,
          status,
          min_points_to_allow_redemption,
          min_points_per_redemption,
          redeem_flag,
          point_equivalent,
          allow_decimal,
          other_earning_types,
          auto_upgrade,
          autoUpgradeFields
        } = data;

        this.formData.membership_program_id = membership_program_id;
        this.formData.name = name;
        this.formData.description = description;
        this.formData.amount_increment = amount_increment;
        this.formData.points_earned = points_earned;
        this.formData.earn_flag = earn_flag;
        this.formData.status = status;
        this.formData.minimum_amount_to_earn = minimum_amount_to_earn;
        this.formData.min_points_to_allow_redemption =
          min_points_to_allow_redemption;
        this.formData.min_points_per_redemption = min_points_per_redemption;
        this.formData.redeem_flag = redeem_flag;
        this.formData.point_equivalent = point_equivalent;
        this.formData.allow_decimal = allow_decimal;
        this.formData.other_earning_types['Payment Earning Type'].payment_type =
          other_earning_types[['Payment Earning Type']].payment_type;
        this.formData.other_earning_types[
          'Payment Earning Type'
        ].amount_increment =
          other_earning_types[['Payment Earning Type']].amount_increment;
        this.formData.other_earning_types[
          'Payment Earning Type'
        ].points_earned =
          other_earning_types[['Payment Earning Type']].points_earned;
        this.formData.other_earning_types[
          'Transaction Earning Type'
        ].transaction_type =
          other_earning_types[['Transaction Earning Type']].transaction_type;
        this.formData.other_earning_types[
          'Transaction Earning Type'
        ].amount_increment =
          other_earning_types[['Transaction Earning Type']].amount_increment;
        this.formData.other_earning_types[
          'Transaction Earning Type'
        ].points_earned =
          other_earning_types[['Transaction Earning Type']].points_earned;

        this.formData.auto_upgrade = auto_upgrade;

        if (autoUpgradeFields) {
          this.formData.auto_upgrade_fields = {
            ...autoUpgradeFields[0],
            target_membership_level_id:
              autoUpgradeFields[0].to_membership_level_id.name,
            upgrade_threshold_amount: autoUpgradeFields[0].amount_threshold
          };
        }
      } else {
        this.clearForm();
      }
    },
    otherEarningTypeChecker(type, event) {
      if (event == 'None' || event == '') {
        for (let param in this.formData.other_earning_types[type]) {
          this.formData.other_earning_types[type][param] = null;
        }
        this.editableEarningTypes[type] = true;
      } else {
        this.editableEarningTypes[type] = false;
      }
    }
  },
  created() {
    this.getMembershipPrograms();
    if (this.membershipLevelData) {
      this.getMembershipLevels(this.membershipLevelData.membership_program_id);
      this.setFormData(this.membershipLevelData);
    }
  },
  watch: {
    membershipLevelData: function (data) {
      this.setFormData(data);
    },
    drawerVisible: function (val) {
      if (val == false) {
        this.closeDrawer();
      }
    }
  },
  computed: {
    earnFlag: {
      get() {
        return this.formData.earn_flag ? true : false;
      },
      set(val) {
        this.formData.earn_flag = val;
      }
    },
    redeemFlag: {
      get() {
        return this.formData.redeem_flag ? true : false;
      },
      set(val) {
        this.formData.redeem_flag = val;
      }
    },
    allowDecimal: {
      get() {
        return this.formData.allow_decimal ? true : false;
      },
      set(val) {
        this.formData.allow_decimal = val;
      }
    }
  }
};
</script>

<style scoped>
.basic-earning-header {
  background-color: #d9edf7; /* light blue like your screenshot */
  color: #333;
  border: none;
}
</style>
